module.exports = __webpack_public_path__ + "static/media/fa-solid-900.f7dce41b.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/fontawesome/fa-solid-900.eot
// module id = 251
// module chunks = 0